import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { I } from '@angular/cdk/keycodes';
import { compactNavigation } from 'app/core/navigation/data';
import _ from 'lodash';
import { permissions } from 'app/core/constants/constants';
import { LocalStorageService } from 'app/core/services/localstorage.service';

@Injectable({
    providedIn: 'root'
})
export class ModuleAuthGuard {
    routeValidation: any;
    companyPolicy = this.utilityService.companyPolicy;

    constructor(public auth: AuthService, public router: Router, public utilityService: UtilityService, private localStorageService: LocalStorageService) {
        this.routeValidation = _.flatten(compactNavigation.map((record) => {
            if(record.children) {
                const returnData = record.children.map((child: any) => ({id: child.id, link: child.link, moduleKey: child.moduleKey}));
                return returnData;
            }
            else {
                return {id: record.id, link: record.link, moduleKey: record.moduleKey};
            }
        }));
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const currentModule = this.routeValidation?.filter((data: any)=>state?.url.includes(data?.link))?.[0];
        const module = route?.routeConfig?.data?.module;
        const path = route?.routeConfig?.path;
        const paymentProvider: any = this.localStorageService.getLocalStorage('paymentProvider')
        let checkPermission = '';
        if(path.includes('new')){
            const windowState = window?.history?.state?.action;
            if(['JOB','PROJECT','ESTIMATES'].includes(module) && windowState === 'clone'){
                checkPermission = 'clone';
            }else{
                checkPermission = 'new';
            }
        }else if(path.includes('edit')){
            checkPermission = 'edit';
        };
        if (
          !this.auth.isModuleAccessable(currentModule) ||
          (this.auth.isModuleAccessable(currentModule) &&
            (path.includes('new') || path.includes('edit')) &&
            !this.utilityService.hasPermission(
              permissions[module][checkPermission]
            ))
        ) {
          window.history.back();
          return false;
        }
        if (path === 'payouts') {
            const companyPolicy = this.utilityService.companyPolicy;
            const isZuperPayEnabled = companyPolicy?.zuper_pay?.is_enabled;
            const userRole = this.utilityService.user?.role.role_key || '';
            const isAdmin = userRole === 'ADMIN';

            if (!isZuperPayEnabled) {
                window.history.back();
                return false;
            }
            if (paymentProvider?.payment_provider_status !== 'RESTRICTED' && isAdmin){
              return true;
            }
            else{
                window.history.back();
                return false; 
            }
        }
        return true;
    }

}
